import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Paper,
  Checkbox,
  FormControl,
  Select
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import { rowDetailType } from "./MemberTable";
//import Waveform from "../../component/common/waveSurfer/WaveForm.js";
import api from "../../../../API";
import ContractRejectRsnDialog from "../manage/contract/ContractRejectRsnDialog";
import PhotoIcon from '@mui/icons-material/Photo';
import DescriptionIcon from '@mui/icons-material/Description';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useSelector } from "react-redux";
import { Formik, Form } from "formik";


// interface userDetailProps {
  
// }
interface MemberDetailProps {
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  rowDetail: rowDetailType | null;
  setRowDetail: React.Dispatch<React.SetStateAction<rowDetailType>>;
  getMemberList: any;
}

const rowData: rowDetailType = {
  id: 0,
  email: "",
  name: "",
  gender: "",
  jumin: "",
  bank: "",
  bank_num: "",
  birth: "",
  phone: "",
  startDate: "",
  roles: []
};

const RoleUpdateDialog = (props: any) => {
  // console.log("props", props);

  const roleRemove = async () => {
    await api.post("/memberRemoveRole",{email:props.email, worker:props.worker, role:props.roleUpdate })
      .then(response => {
        // console.log('getDocumentFile' ,response.data.datas)
        alert("권한 제거가 완료되었습니다.")
        props.setRoleUpdateDialog(false);
        props.closeDialogAfterRoleUpdate();
        // props.getMemberList();
        // setDocumentFile(response.data.datas)
      })
      .catch((e:any) => console.log('사용자 권한 업데이트 실패' , e));
  }
  
  return (
    <Dialog maxWidth="xs" open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>권한 업데이트</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
        <DialogContent dividers>
        <Box display="flex" justifyContent="center">
          {props.roleUpdateName} 권한을 삭제 하시겠습니까?
        </Box>

        </DialogContent>
        

          <DialogActions>
            <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                props.setRoleUpdateDialog(false);
              }}
            >
              취소
            </Button>
            <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                roleRemove()
              }}
            >
              권한 삭제
            </Button>
          </DialogActions>
      {/* 취소
        </Button>
        <Button variant="contained" color="error" sx={{fontWeight:700, margin:"8px 16px"}}
          // onClick={() => { */}
          {/* //   // sampleReject();
          //   setRejectPageOpen(true);
          // 
        > */}

          {/* 샘플 검수반려
        {/* </Button>
        <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}} */}
          {/* // onClick={() => { */}
          {/* //   sampleConfirm();
          //  */}
    </Dialog>
  );
};

export default RoleUpdateDialog;
